import React from 'react';
import Profissional from '../../../components/Profissionais/Profissionais';
import LuisaImg from '../../../assets/profissionais/luisa.png';

function Luisa() {
  return (
    <Profissional 
      nome="Luísa Viana"
      customClass="profissional-luisa"
      cargo="Arte Terapeuta"
      imagem={LuisaImg}
      descricao={
        <>
          <div className="profissional-descricao">
            <p>Me chamo Luísa Viana, sou professora de Arte, formada em Artes Visuais pela Universidade de Sorocaba, atuo na área há 3 anos e sou pós graduada em Arteterapia. </p><br></br>

            <p>Minha busca é sempre levar a arte em lugares que ela faça a diferença! 
              Me encontrei dentro da sala de aula ensinando turmas desde o pré até o ensino médio. 
              Meu foco também se tornou trabalhar a arte como cura, como um poderoso instrumento do autoconhecimento. </p><br></br>

            <p> Dentro das sessões de Arteterapia nossas atividades tem esse objetivo, pouco importa habilidades artísticas, estou aqui em prol da saúde!</p>

            <p className='text-highlight'>Quem pode fazer Arteterapia?</p>

            <p>A Arteterapia é um instrumento terapêutico para todos, pois favorece a expressão por ser um poderoso canal de manifestação 
            da subjetividade. Amplia as possibilidades de expressão, indo além da abordagem tradicional que é baseada na linguagem verbal.
            </p>

            <p className='text-highlight'>Por que fazer Arteterapia?</p>

            <p>A Arteterapia ajuda a se conectar com o seu interior, trabalhando livremente com técnicas artísticas. Promovendo o autoconhecimento, a autoestima e confiança, apurar a concentração e memória, além de entender as emoções de forma saudável.</p>
            
            <p className='text-highlight'>Com o que trabalhamos na Arteterapia?</p>
            
            <p>Podemos trabalhar com diversas técnicas, como a escrita terapêutica, colagem, desenhos, pinturas, movimentos corporais, contação de histórias entre outros.</p>
          </div>
        </>
      }
    />
  );
}

export default Luisa;
